import React from "react";
import styled from "styled-components";
import { FaStickyNote, FaHome, FaTimes, FaEnvelope } from "react-icons/fa";
import {
  FaComputerMouse,
  FaGithub,
  FaLinkedin,
  FaFreeCodeCamp,
} from "react-icons/fa6";
import useEscapeKey from "../hooks/useEscapeKey";

import { Link } from "react-router-dom";

const Sidebar = ({ sidebarIsOpen, setSidebarIsOpen }) => {
  useEscapeKey(setSidebarIsOpen);
  return (
    <Wrapper>
      <div
        className={sidebarIsOpen ? "show sidebar-overlay" : "sidebar-overlay"}
      >
        <aside className="sidebar">
          <button
            onClick={() => setSidebarIsOpen(false)}
            className="sidebar-close"
            aria-label="close"
          >
            <FaTimes />
          </button>
          <ul className="sidebar-links">
            <li className="sidebar-link">
              <FaHome className="fa-icon" />
              <Link
                onClick={() => setSidebarIsOpen(false)}
                className="link"
                to="/"
              >
                Home
              </Link>
            </li>
            <li className="sidebar-link">
              <FaComputerMouse className="fa-icon" />
              <Link
                onClick={() => setSidebarIsOpen(false)}
                className="link"
                to="/projects"
              >
                Projects
              </Link>
            </li>

            <li className="sidebar-link">
              <div className="icon-container">
                <FaEnvelope className="fa-icon" />
              </div>
              <Link
                onClick={() => setSidebarIsOpen(false)}
                className="link"
                to="/contact"
              >
                Contact
              </Link>
            </li>
            <li className="sidebar-link">
              <FaStickyNote className="fa-icon" />
              <Link
                onClick={() => setSidebarIsOpen(false)}
                className="link"
                to="/course-notes"
              >
                Course Notes
              </Link>
            </li>
          </ul>
          {/* social icons */}
          <div className="social-icons">
            {/* <!-- single icon --> */}
            <a
              aria-label="visit my github profile"
              className="social-icon-dark"
              href="https://github.com/Hallelujah78"
            >
              <FaGithub />
            </a>
            {/* <!-- end of single icon --> */}
            {/* <!-- single icon --> */}
            <a
              aria-label="visit my linkedin profile"
              className="social-icon-dark"
              href="https://www.linkedin.com/in/gavan-browne/"
            >
              <FaLinkedin />
            </a>
            {/* <!-- end of single icon --> */}
            {/* <!-- single icon --> */}
            <a
              aria-label="visit my free code camp profile"
              className="social-icon-dark"
              href="https://www.freecodecamp.org/hallelujah78"
            >
              <FaFreeCodeCamp />
            </a>
            {/* <!-- end of single icon --> */}
          </div>
        </aside>
      </div>
    </Wrapper>
  );
};

export default Sidebar;

const Wrapper = styled.div`
  .social-icons {
    width: 80%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    bottom: 2rem;

    justify-content: space-around;
  }

  .social-icon-dark {
    background: transparent;
    font-size: 2.5rem;
    color: var(--grey-500);
  }
`;
